<div *ngIf="isOpen" class="screen-message-container">
  <i class="xos-icon icon-warning"></i>
  <h3>{{ title }}</h3>
  <span>{{ mainText }}</span>
  <a (click)="toggleWebWidget()" class="xos-link">Contact support</a>
  <i class="xos-icon icon-close" (click)="close()"></i>
</div>
